var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyEth = function SvgIconCurrencyEth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.208.89-8.23 10.475a1 1 0 0 0-.205.85c.034.153.104.297.204.42l8.23 10.475a1 1 0 0 0 .793.39 1 1 0 0 0 .793-.39l8.23-10.475a1.005 1.005 0 0 0 0-1.27L12.793.89a.997.997 0 0 0-1.585 0m7.47 10.727L13 4.39v9.806zm-1.749 2.99L13 16.395v3.215zM11 19.61v-3.215l-3.929-1.786zm-5.677-7.992L11 14.197V4.391z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCurrencyEth;